<template>
   <div class="lesson-list container-fluid bottom-dotted-border margin-Top-Bottom-1Point5Perc" v-bind:isBonus="isBonusModule"> 
        <div class="admin-Panel-Padding">
            <div class="row vertical-align text-align-left lesson-index-text-size">
              <div class="col-md-2 col-lg-2"></div>
              <div class="col-md-10 col-lg-10 text-color-orange"><span v-html="getTopicName"></span></div>
            </div>
            <div class="row vertical-align">
             <div class="col-md-1 col-lg-1">
               <!-- ToDo: Track this -->
                 <img src= "../assets/images/reorder.svg" class="cursor-pointer img-responsive icon-width-height opacity-point-2 align-center" alt="drag">
             </div>
             <div class="col-md-1 col-lg-1">
               <!-- ToDo: Track this -->
                 <div class="arrow-right align-center" v-bind:class="{'arrow-down': showElementList}" v-on:click="updateShowElementListFlag"></div>
             </div>
             <div class="col-md-7 col-lg-7">
                 <div class="row cursor-pointer" v-on:click="updateShowElementListFlag">
                     <div class="col-md-5 col-lg-5 text-align-left lesson-index-text-size">
                         {{getLessonNumber}}<span>{{getModuleDuration}}</span>
                     </div>
                    <div class="col-md-7 col-lg-7 cursor-default" v-if="LessonObj.ModuleType === constants.ModuleType.Normal">
                      <div class="row vertical-align padding-0perc text-align-left lesson-index-text-size">
                        <div class="tooltip1 margin-right-2px">
                          <img :src="getIsOptionalSrcValue" class="img-responsive icon-width-height-content-locked-bonus align-center margin-0Perc" alt="isOptional">
                          <span class="tooltiptext1">{{getIsOptionalTooltipValue}}</span>
                        </div>
                        <div class="tooltip1 margin-right-2px">
                          <img :src="getIsUnlockedSrcValue" class="img-responsive icon-width-height-content-locked-bonus align-center" alt="isUnlocked">
                          <span class="tooltiptext1">{{getIsUnlockedTooltipValue}}</span>  
                        </div>
                        <span class="text-align-left tooltip1 margin-left-5px margin-right-2px">{{getHumanReadableDate(getLessonObject.ReleaseDate)}}</span>
                      </div>
                    </div>
                 </div>
                 <div class="row cursor-pointer padding-top-2px" v-on:click="updateShowElementListFlag">
                     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-align-left lesson-name-text-size lesson-name-style">
                         {{LessonObj.Title}}
                     </div>
                 </div>        
             </div>
             <div class="col-md-1 col-lg-1">
               <!-- ToDo: Track this -->
                 <img src= "../assets/images/importicon.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="import" v-on:click="setShowImportLessonAsTrue($event,true)">
                 <import-lesson-element-overlay v-show="showImportLessonElementOverlay" :currentLessonObj="getLessonObject" :isComingFrom="isComingFrom" @closeOverlay="updateShowImportLessonElementOverlay" @showSpinner="updateShowSpinnerFlag" v-bind:selectedLessonObj="getLessonObject"></import-lesson-element-overlay>
             </div>
             <div class="col-md-1 col-lg-1">
               <!-- ToDo: Track this -->
                 <img src= "../assets/images/edit.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="edit" v-on:click="setShowUpdateLessonAsTrue($event,true)">
                 <update-lesson-overlay v-show="showUpdateLessonOverlay" @ShowUpdateLesson="updateShowUpdateLessonFlag" @showSpinner="updateShowSpinnerFlag" v-bind:selectedLessonObj="getLessonObject"></update-lesson-overlay>
             </div>
             <div class="col-md-1 col-lg-1">
               <!-- ToDo: Track this -->
                 <img src= "../assets/images/delete.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="delete" v-on:click="setShowConfirmationBoxAsTrue($event,true)">
                 <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="getLessonObject" v-bind:prefixString="prefixDeleteLessonString" v-bind:postfixString="postDeleteLessonString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedLesson"></confirmation-alert>
             </div>    
            </div>
        </div> 
        <div class="row">
          <div class="drag">
              <draggable :elementListValue="elementListValue" v-model="elementListValue" v-if="showElementList">
                <transition-group>
                  <element-list v-for="eleObj in elementListValue" :key="eleObj.Index" v-bind:ElementObj="eleObj" v-bind:elementList="elementListValue" v-bind:lessonObj="LessonObj" @updatedElementList="updatedElementList"></element-list>
                </transition-group>
              </draggable>
          </div>
            <lesson-list-add-bonus-element-option v-if="showElementList&&(isBonusModule)" v-bind:lessonObj="getLessonObject" @refreshBonusList="updatedElementList"></lesson-list-add-bonus-element-option>
            <lesson-list-create-elemement-option v-if="showElementList&&(!isBonusModule)" v-bind:lessonObj="getLessonObject" @updatedElementList="updatedElementList"></lesson-list-create-elemement-option>
        </div>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
            <div class="osahanloading"></div>
        </div>
        <!-- <loader></loader> -->
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import draggable from 'vuedraggable'
import { elementService } from '@/server-util/element-service'
import { moduleService } from '@/server-util/module-service'
import ElementList from '@/components/ElementList'
import LessonListCreateElementOption from '@/components/LessonListCreateElementOption'
import LessonListAddBonusElementOption from '@/components/LessonListAddBonusElementOption'
import UpdateLessonOverlay from '@/components/UpdateLessonOverlay'
import ImportLessonElementOverlay from '@/components/ImportLessonElementOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import bonusicon from '../assets/images/bonus.svg'
import nobonusicon from '../assets/images/nobonus.svg'
import lockicon from '../assets/images/lock.svg'
import unlockicon from '../assets/images/unlock.svg'
import optionalicon from '../assets/images/optional.svg'
import compulsoryicon from '../assets/images/compulsory.svg'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import forEach from 'lodash/forEach'
import isEqual from 'lodash/isEqual'
export default {
  props: ['LessonObj', 'isComingFrom'],
  name: 'lesson-list',
  created: function () {
    this.setTopicTitle()
  },
  data: function () {
    return {
      constants: constants,
      isBonusContentSrc: '',
      isBonusContentTooltip: '',
      isOptionalSrc: '',
      isOptionalTooltip: '',
      isUnlockedSrc: '',
      isUnlockedTooltip: '',
      ElementObjList: [],
      originalElemList: [],
      showElementList: false,
      showUpdateLessonOverlay: false,
      showImportLessonElementOverlay: false,
      showConfirmationBox: false,
      prefixDeleteLessonString: '',
      postDeleteLessonString: '',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      reIndexedObj: {
        ModuleId: '',
        StepList: []
      },
      TopicName: ''
    }
  },
  methods: {
    setTopicTitle: function () {
      if (this.LessonObj.MasterTopic !== undefined && this.LessonObj.MasterTopic !== null && this.LessonObj.MasterTopic !== '') {
        this.getTopicName = '<b>Topic:</b> ' + this.LessonObj.MasterTopic.Title
      } else {
        this.getTopicName = ''
      }
    },
    updateShowImportLessonElementOverlay (value) {
      // AK: Used to close the Import Lesson Element Overlay
      this.showImportLessonElementOverlay = false
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = false
      // AK: If user imported lesson element
      if (value.isImportedLessonElement) {
        this.getElements()
      }
    },
    getHumanReadableDate (date) {
      return dmAdminUtils.getHumanReadableEST(date + 'Z')
    },
    updatedElementList (value) {
      this.originalElemList = value
      this.ElementObjList = value
      this.updateStepNumbering(false)
      // console.log('Updated Element List >>> ' + JSON.stringify(this.ElementObjList))
    },
    updateShowElementListFlag: function (event) {
      if (!this.showElementList) {
        this.getElements()
      } else {
        this.showElementList = !this.showElementList
      }
    },
    setShowUpdateLessonAsTrue: function (event, flagToUpdate) {
      // AK: Used when user pressed edit button to open update lesson overlay
      this.showUpdateLessonOverlay = flagToUpdate
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    setShowImportLessonAsTrue: function (event, flagToUpdate) {
      // AK: Used when user pressed import button to open Import lesson overlay
      this.showImportLessonElementOverlay = flagToUpdate
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateShowUpdateLessonFlag (value) {
      // AK: Used when user pressed close button of update lesson overlay
      this.showUpdateLessonOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateShowConfirmationAlertFlag (value) {
      // console.log('LessonObj >>>' + JSON.stringify(this.LessonObj))
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      // AK: If user terminate swip element operation then re-assign original list
      if (this.prefixDeleteLessonString === 'Are you sure you want to re-order selected step in ') {
        this.ElementObjList = this.originalElemList
      }
    },
    setShowConfirmationBoxAsTrue: function (event, flagToUpdate) {
      // AK: Used when user pressed delete button to open delete lesson overlay
      // console.log('Selected Lesson Obj : ' + JSON.stringify(this.LessonObj))
      if (!this.LessonObj.IsBonusContent) {
        this.prefixDeleteLessonString = 'Are you sure you want to delete '
        this.postDeleteLessonString = ' lesson?'
      } else {
        this.prefixDeleteLessonString = ''
        this.postDeleteLessonString = ' (Bonus Lesson) you are trying to delete may have bonus step(s) associated with it. You need to perform the association again for those bonus step(s) to work properly.'
      }
      this.showConfirmationBox = flagToUpdate
    },
    deleteSelectedLesson (value) {
      // AK: Hide Confirmation Box
      this.showConfirmationBox = false
      if (this.postDeleteLessonString === '?') {
        // AK: User trying to swip elements
        if (value) {
          this.reIndexedObj.StepList = []

          this.reIndexedObj.ModuleId = this.LessonObj.ModuleId
          var minElementIndex = this.LessonObj.MinElementIndex

          for (var i = 0; i < this.ElementObjList.length; i++) {
            // AK: create Object initially
            var elementObj = {
              ElementId: this.ElementObjList[i].ElementId,
              Type: this.ElementObjList[i].Type,
              Title: this.ElementObjList[i].Title,
              OldIndex: 0,
              NewIndex: 0
            }
            // AK: For very first element object, use minIndex and later on increase it by one
            if (i !== 0) {
              minElementIndex += 1
            }
            elementObj.OldIndex = parseInt(this.ElementObjList[i].Index)
            elementObj.NewIndex = parseInt(minElementIndex)

            this.reIndexedObj.StepList.push(elementObj)
          }
          this.reIndexElement()
          // this.ElementObjList = this.originalElemList
        }
      } else {
        // AK: Performed Delete operation
        var _this = this
        var storeObj = this.$store
        if (value) {
          if (
            this.LessonObj.ModuleId !== undefined ||
            this.LessonObj.length > 0
          ) {
            // this.showSpinner = true
            this.$store.state.isLoading = true
            moduleService
              .deleteModule(storeObj.state.access_token, _this.LessonObj.ModuleId)
              .then(responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Refresh Lesson List
                  _this.getLessons()
                } else {
                  this.showAlertDialog = true
                  this.errorMsg = 'Oops! Something went wrong. Please try again.'
                  // this.showSpinner = false
                  this.$store.state.isLoading = false
                }
              }, errorObj => {
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              })
          } else {
            console.log(
              'Selected Lesson Object is NULL hence declined DELETE OPERATION'
            )
          }
        }
      }
    },
    getLessons: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== undefined
      ) {
        moduleService
          .listModules(
            storeObj.state.access_token,
            storeObj.state.selectedCourseObjFromFilter.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.selectedMasterClassModuleList = responseObj.data
              // AK: Hide Spinner after recieving updated Lesson list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'CourseMasterId is NULL hence declined REFRESH LESSON LIST OPERATION'
        )
      }
    },
    reIndexElement: function () {
      var _this = this

      if (_this.reIndexedObj.StepList[0].Type === 7) {
        this.showAlertDialog = true
        this.errorMsg = 'First step can\'t be of bonus content type.'
        this.ElementObjList = this.originalElemList
        return
      }
      var elemLen = _this.reIndexedObj.StepList.length
      if (_this.reIndexedObj.StepList[elemLen - 1].Type === 7) {
        this.showAlertDialog = true
        this.errorMsg = 'Last step can\'t be of bonus content type.'
        this.ElementObjList = this.originalElemList
        return
      }
      let hasSuccessiveBonusSteps = false
      for (var ii = 0; ii < elemLen; ii++) {
        if (ii > 0) {
          const prevStep = _this.reIndexedObj.StepList[ii - 1]
          const currStep = _this.reIndexedObj.StepList[ii]
          const nextStep = _this.reIndexedObj.StepList[ii + 1]
          if (currStep.Type === 7 && (prevStep.Type === 7 || (nextStep && nextStep.Type === 7))) {
            hasSuccessiveBonusSteps = true
            break
          }
        }
      }

      if (hasSuccessiveBonusSteps) {
        this.showAlertDialog = true
        this.errorMsg = 'Successive bonus steps are not allowed.'
        this.ElementObjList = this.originalElemList
        return
      }

      var storeObj = this.$store
      if (
        this.reIndexedObj.ModuleId !== undefined ||
        this.reIndexedObj.ModuleId !== ''
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        elementService
          .reIndexElements(storeObj.state.access_token, _this.reIndexedObj)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Assign newly recieved list
              _this.ElementObjList = responseObj.data
              _this.originalElemList = responseObj.data
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                _this.showElementList = true
              } else {
                // console.log('Server call List elements')
                _this.updateStepNumbering(false)
              }
            } else {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected COURSEMASTERID is NULL hence declined RE-INDEXING LESSON OPERATION'
        )
      }
    },
    updateShowSpinnerFlag (value) {
      // AK: As Soon as User update request send to server show spinner and Hide spinner after recieving updated list
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    getElements: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      // alert(this.LessonObj.ModuleId)
      if (
        this.LessonObj.ModuleId !== undefined &&
        this.LessonObj.ModuleId !== null
      ) {
        elementService
          .listElements(storeObj.state.access_token, this.LessonObj.ModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Assign it to ElementObj and originalElemList as copy if user revert swip operation
              this.ElementObjList = responseObj.data
              this.originalElemList = responseObj.data
              // AK: Hide Spinner after recieving updated Lesson list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                _this.showElementList = true
              } else {
                console.log('Server call List elements')
                _this.updateStepNumbering(true)
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ModuleId is NULL hence declined LOADING ELEMENT LIST OPERATION'
        )
      }
    },
    updateStepNumbering: function (comingFromServerResp = true) {
      // console.log('updateStepNumbering')
      this.$store.state.isLoading = true
      const hasAttachedMasterTopic = this.LessonObj.MasterTopic !== undefined && this.LessonObj.MasterTopic !== null && this.LessonObj.MasterTopic !== 'null' && this.LessonObj.MasterTopic !== ''
      var currChar = parseInt('A'.charCodeAt(0), 10)
      var lastAppendedStr = ''
      var lastAppendedChar = parseInt('A'.charCodeAt(0), 10)
      var cnt = 1
      forEach(this.originalElemList, (currEleObj) => {
        var stepIndexToDisplay = cnt
        if (hasAttachedMasterTopic) {
          if (currEleObj.Type !== 7) {
            var updatedNewChar = parseInt((currChar++), 10)
            stepIndexToDisplay = (this.LessonObj.DisplayIndex + lastAppendedStr + String.fromCharCode(updatedNewChar))
            if (String.fromCharCode(updatedNewChar) === 'Z') {
              currChar = parseInt(('A'.charCodeAt(0)), 10)
              var preAppendedStrLen = lastAppendedStr.length
              if (preAppendedStrLen > 0) {
                lastAppendedChar = parseInt((lastAppendedStr.charAt(preAppendedStrLen - 1).charCodeAt(0)), 10)
                lastAppendedChar++
              }
              // AK: Touched/Completed last Z series as well.
              if (String.fromCharCode(lastAppendedChar) === '[') {
                lastAppendedChar = parseInt(('A'.charCodeAt(0)), 10)
                if (preAppendedStrLen > 0) {
                  lastAppendedStr = lastAppendedStr.substring(0, (preAppendedStrLen - 1)) + 'A'
                } else {
                  lastAppendedStr[0] = 'A'
                }
                lastAppendedStr += 'A'
              } else {
                if (preAppendedStrLen > 1) {
                  lastAppendedStr = lastAppendedStr.substring(0, preAppendedStrLen - 1) + String.fromCharCode(lastAppendedChar)
                } else {
                  lastAppendedStr = String.fromCharCode(lastAppendedChar)
                }
              }
            }
          } else {
            stepIndexToDisplay = 'B'
          }
        } else {
          if (currEleObj.Type !== 7) {
            stepIndexToDisplay = cnt
            cnt++
          } else {
            stepIndexToDisplay = 'B'
          }
        }
        // console.log('currEleObj.DisplayIndex: ' + stepIndexToDisplay)
        currEleObj.DisplayIndex = stepIndexToDisplay
      })
      this.ElementObjList = this.originalElemList
      if (!comingFromServerResp) {
        // console.log('Close and reopen list called')
        this.showElementList = false
        setTimeout(() => {
          this.showElementList = true
          this.$store.state.isLoading = false
        }, 10)
      } else {
        this.showElementList = true
        this.$store.state.isLoading = false
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'element-list': ElementList,
    'lesson-list-create-elemement-option': LessonListCreateElementOption,
    'update-lesson-overlay': UpdateLessonOverlay,
    'import-lesson-element-overlay': ImportLessonElementOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'lesson-list-add-bonus-element-option': LessonListAddBonusElementOption,
    draggable,
    'loader': Loader
  },
  computed: {
    getExpandAllLessonsFlag: {
      get: function () {
        return this.$store.state.expandAllLessons
      }
    },
    getMasterTopicList: {
      get: function () {
        return this.$store.state.masterTopicList
      }
    },
    getTopicName: {
      get: function () {
        return this.TopicName
      },
      set: function (newValue) {
        this.TopicName = newValue
      }
    },
    getModuleDuration: {
      get: function () {
        var durationToReturn = this.getLessonObject.Duration !== undefined && this.getLessonObject.Duration !== '' && this.getLessonObject.Duration !== null && this.getLessonObject.Duration !== 'null' ? ' / ' + this.getLessonObject.Duration : ''
        return durationToReturn
      }
    },
    getIsOptionalSrcValue: {
      get: function () {
        this.isOptionalSrc = this.getLessonObject.IsOptional ? optionalicon : compulsoryicon
        return this.isOptionalSrc
      }
    },
    getIsOptionalTooltipValue: {
      get: function () {
        this.isOptionalTooltip = this.getLessonObject.IsOptional ? constants.Is_Optional_True_Tooltip_Text : constants.Is_Optional_False_Tooltip_Text
        return this.isOptionalTooltip
      }
    },
    getIsUnlockedSrcValue: {
      get: function () {
        this.isUnlockedSrc = this.getLessonObject.IsUnlocked ? unlockicon : lockicon
        return this.isUnlockedSrc
      }
    },
    getIsUnlockedTooltipValue: {
      get: function () {
        this.isUnlockedTooltip = this.getLessonObject.IsUnlocked ? constants.Is_Unlocked_True_Tooltip_Text : constants.Is_Unlocked_False_Tooltip_Text
        return this.isUnlockedTooltip
      }
    },
    getIsBonusContentSrcValue: {
      get: function () {
        this.isBonusContentSrc = this.getLessonObject.IsBonusContent ? bonusicon : nobonusicon
        return this.isBonusContentSrc
      }
    },
    getIsBonusContentTooltipValue: {
      get: function () {
        this.isBonusContentTooltip = this.getLessonObject.IsBonusContent ? constants.Is_Bonus_Content_True_Tooltip_Text : constants.Is_Bonus_Content_False_Tooltip_Text
        return this.isBonusContentTooltip
      }
    },
    getLessonObject () {
      this.setTopicTitle()
      return this.LessonObj
    },
    elementListValue: {
      get: function () {
        return this.ElementObjList
      },
      set: function (newValue) {
        this.showConfirmationBox = true
        this.prefixDeleteLessonString = 'Are you sure you want to re-order selected step in '
        this.postDeleteLessonString = '?'
        this.ElementObjList = newValue
        // console.log('Re-arranged List >>>> ' + JSON.stringify(this.ElementObjList))
      }
    },
    getLessonNumber: {
      get: function () {
        if (this.isBonusModule) {
          return 'Bonus Content'
        } else {
          var valueToReturn = ''
          switch (this.getLessonNumberingValue) {
            default:
            case constants.LessonNumberingType.Default:
              valueToReturn = 'Lesson ' + this.getLessonObject.DisplayIndex
              break
            case constants.LessonNumberingType.Custom:
              valueToReturn = this.getLessonObject.LessonNumberText !== null && this.getLessonObject.LessonNumberText !== undefined && this.getLessonObject.LessonNumberText !== 'null' && this.getLessonObject.LessonNumberText !== 'undefined' && this.getLessonObject.LessonNumberText !== '' ? this.getLessonObject.LessonNumberText : 'Data Missing'
              break
            case constants.LessonNumberingType.Hide:
              valueToReturn = 'NA'
              break
          }
          return valueToReturn
        }
      }
    },
    isBonusModule: {
      get: function () {
        return this.getLessonObject.IsBonusContent
      }
    },
    getCurrentCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getLessonNumberingValue: {
      get: function () {
        return parseInt(this.getCurrentCourseObj.LessonNumbering)
      }
    }
  },
  watch: {
    getLessonObject: function (newValue, oldValue) {
      if (!isEqual(oldValue.MasterTopic, newValue.MasterTopic)) {
        // console.log('watch')
        this.updateStepNumbering(false)
      }
    },
    getExpandAllLessonsFlag: function (newValue, oldValue) {
      var valueToUpdate = false
      console.log('newValue: ' + newValue)
      if (newValue.indexOf('true') > -1) {
        valueToUpdate = true
      }
      if (this.showElementList !== valueToUpdate) {
        this.showElementList = valueToUpdate
        console.log('this.showElementList: ' + this.showElementList)
        if (valueToUpdate) {
          this.getElements()
        }
      } else {
        console.log('Already having same selected operation: ' + this.LessonObj.Title)
      }
    }
  }
}
</script>
<style scoped>
.text-color-orange {
  color: #f39c12;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.opacity-point-2 {
  opacity: 0.5;
}
.cursor-pointer {
  cursor: pointer;
}
.lesson-list {
  width: 100%;
}
.lesson-name-style {
  font-weight: bold;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #34495e;
  cursor: pointer;
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #34495e;
  cursor: pointer;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.icon-width-height {
  width: 24px;
  height: 29px;
}
.icon-width-height-content-locked-bonus {
  width: 21px;
  height: 21px;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.align-center {
  margin: 0 auto !important;
}
.text-align-left {
  text-align: left;
}
.lesson-name-text-size {
  font-size: 17px;
}
.lesson-index-text-size {
  font-size: 14px;
}
.border-red {
  border: 1px solid red;
}
.tooltip1 {
    position: relative;
    display: inline-block;
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    /* width: 133px; */
    width: -webkit-fill-available;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 1px;
    position: absolute;
    z-index: 1;
    top: 130%;
    left: 140%;
    margin-left: -50px;
    font-size:12px;
  }

.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.padding-0perc {
  padding:0%;
}
.margin-0Perc {
  margin: 0%;
}
.cursor-default {
  cursor: default;
}
.padding-left-0perc {
  padding-left:0%;
}
.padding-top-2px {
  padding-top:2px;
}
.margin-right-2px {
  margin-right:2px;
}
.margin-left-5px {
  margin-left:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/LessonList.vue